/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snapshot_History_Select_Aria_LabelInputs */

const en_snapshot_history_select_aria_label = /** @type {(inputs: Snapshot_History_Select_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select commit snapshot`)
};

const fr_snapshot_history_select_aria_label = /** @type {(inputs: Snapshot_History_Select_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectionner un snapshot de commit`)
};

const de_snapshot_history_select_aria_label = /** @type {(inputs: Snapshot_History_Select_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Snapshot-Speicherung auswählen`)
};

const it_snapshot_history_select_aria_label = /** @type {(inputs: Snapshot_History_Select_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona l'istantanea del commit`)
};

const ru_snapshot_history_select_aria_label = /** @type {(inputs: Snapshot_History_Select_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите снимок коммита`)
};

const es_snapshot_history_select_aria_label = /** @type {(inputs: Snapshot_History_Select_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar instantánea de confirmación`)
};

const zh_cn2_snapshot_history_select_aria_label = /** @type {(inputs: Snapshot_History_Select_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择提交快照`)
};

const ja_snapshot_history_select_aria_label = /** @type {(inputs: Snapshot_History_Select_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コミットスナップショットを選択`)
};

const hi_snapshot_history_select_aria_label = /** @type {(inputs: Snapshot_History_Select_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कमिट स्नैपशॉट चुनें`)
};

const pt_pt2_snapshot_history_select_aria_label = /** @type {(inputs: Snapshot_History_Select_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione "Confirmar snapshot"`)
};

/**
* | output |
* | --- |
* | "Select commit snapshot" |
*
* @param {Snapshot_History_Select_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snapshot_history_select_aria_label = /** @type {((inputs?: Snapshot_History_Select_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snapshot_History_Select_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_snapshot_history_select_aria_label(inputs)
	if (locale === "de") return de_snapshot_history_select_aria_label(inputs)
	if (locale === "it") return it_snapshot_history_select_aria_label(inputs)
	if (locale === "ru") return ru_snapshot_history_select_aria_label(inputs)
	if (locale === "es") return es_snapshot_history_select_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_snapshot_history_select_aria_label(inputs)
	if (locale === "ja") return ja_snapshot_history_select_aria_label(inputs)
	if (locale === "hi") return hi_snapshot_history_select_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_snapshot_history_select_aria_label(inputs)
	return en_snapshot_history_select_aria_label(inputs)
});